import React, { useState, useEffect } from "react";
import ReferralCheck from "./ReferralLogins/ReferralCheck.module";
import styles from "./Login.module.css";
import Register from "./ReferralLogins/Register.module";
import irluxepic from "./../../images/irluxe-black.png";
import LoadingCircl from "../../Components/LoadingCircl/LoadingCircl.module";
const ReferralLogin = ({ setLoginReferral }) => {
  const [stepReferral, setStepReferral] = useState(1);
  const [referralCode, setReferralCode] = useState("");
  const [referralPassword, setReferralPassword] = useState("");
  const [loading, setLoading] = useState(false);
  return (
    <>
      {loading && <LoadingCircl />}
      <div className={styles.topLogin}>
        <div className={styles.logo}>
          <img src={irluxepic} />
        </div>
      </div>
      <div className={styles.whiteBox}>
        {stepReferral == 1 && (
          <ReferralCheck
            setLoginReferral={setLoginReferral}
            changeStep={setStepReferral}
            setLoading={setLoading}
            loading={loading}
            setReferralCode={setReferralCode}
            setReferralPassword={setReferralPassword}
            referralPassword={referralPassword}
            referralCode={referralCode}
          />
        )}
        {stepReferral == 2 && (
          <Register
            setLoginReferral={setLoginReferral}
            changeStep={setStepReferral}
            setLoading={setLoading}
            loading={loading}
            referralCode={referralCode}
            referralPassword={referralPassword}
          />
        )}
      </div>
    </>
  );
};

export default ReferralLogin;
